import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { initSessionFromCookie } from "../actions/session";
import { connect } from 'react-redux'


const mapStateToProps = state => {
    return { session: state.session }
}

function mapDispatchToProps(dispatch) {
    return {
        initSessionFromCookie: () => dispatch(initSessionFromCookie())
    }
}

class PrivateRoute extends Component {
    constructor(props) {
        super(props)
        this.state = { initSessionFromCookie: true }
        this.props.initSessionFromCookie()
            .then(() => { this.setState({ initSessionFromCookie: false }) })
    }

    render() {
        if (this.state.initSessionFromCookie) {
            return <div />
        }
        const { component: Component, ...rest } = this.props;
        if (!this.props.session.isLoggedIn) {
            const redirectPath = window.location.pathname
            localStorage.setItem('redirectPath', redirectPath);
        }
        return <Route {...rest} render={props => (
            this.props.session.isLoggedIn ?
                <Component {...props} />
                : <Redirect to='/login' />
        )} />
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)